import SiteNav from './SiteNav';
import Footer from './Footer';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import './App.css';

const CONTACT_EMAIL = 'info@positivegrain.com';

export default function Contact() {
  const { lang } = useLanguage();
  const t = translations[lang].contact;

  return (
    <div className="simple-page">
      <SiteNav />

      <div className="contact-page-content">
        <div className="contact-inner">
          <h1 className="contact-headline-full">
            {t.headlineLine1}
            <br />
            {t.headlineLine2}
          </h1>

          <div className="contact-utility">
            <div className="contact-utility-row">
              <span className="contact-utility-label">{t.email}</span>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="contact-utility-value"
              >
                {CONTACT_EMAIL}
              </a>
            </div>
            <div className="contact-utility-row">
              <span className="contact-utility-label">{t.instagram}</span>
              <a
                href="https://instagram.com/positivegrain"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-utility-value"
              >
                @positivegrain
              </a>
            </div>
            <div className="contact-utility-row">
              <span className="contact-utility-label">{t.location}</span>
              <span className="contact-utility-value">
                {t.locationValue}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}